import { Model } from "@vuex-orm/core";
import { required, maxLength, minLength } from "vuelidate/lib/validators";
import Project from "./Project";

export default class ProjectMaterial extends Model {
  static entity = 'projectmaterials';

  static $fetch() {
    return this.api().get('ProjectMaterials/')
  }
  static $get (id) {
    return this.api().get(`ProjectMaterials/${id}/`)
  }
  static $post (data) {
    return this.api().post(`ProjectMaterials/`, data)
  }
  static $put (id, data) {
    return this.api().put(`ProjectMaterials/${id}/`, data)
  }
  static $delete (id) {
    return this.api().delete(`ProjectMaterials/${id}/`, { delete: id })
  }

  static fields() {
    return {
      id: this.attr(null),
      name: this.string(""),
      icon: this.string("fas fa-luggage-cart"),
      project: this.belongsTo(Project, "project_id"),
      project_id: this.attr(null),
      received: this.boolean(false),
      received_on: this.string(new Date().toISOString().substr(0 ,10)),
      expected_quantity: this.string(""),
      notes: this.string("")
    };
  }
  static get validations() {
    return {
      formdata: {
        name: { required, maxLength: maxLength(124), minLength: minLength(6) },
        notes: { maxLength: maxLength(124) },
        expected_quantity: { required, maxLength: maxLength(28) }
      }
    };
  }
  getReceivedDate() {
    return new Date(this.received_on).toDateString();
  }
  toCreatePayload() {
    return {
      name: this.name,
      notes: this.notes,
      project: this.project_id,
      received: this.received,
      received_on: this.received_on,
      expected_quantity: this.expected_quantity
    };
  }

  toUpdatePayload() {
    return {
      ...this.toCreatePayload(),
      id: this.$id
    };
  }
}

